import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import DraggableAppModal from '../Modals/DraggableAppModal';

const AddFeedbackDialog = ({ alert, onCancel, onApply, paperStyle }, context) => {
  const [feedback, setFeedback] = useState('');

  const actions = (
    <>
      <Button variant="contained" color="primary" endIcon={<SendIcon />}
        // disabled={!feedback.trim()}
        onClick={() => onApply(feedback)}>
        {context.t('apply_changes')}
      </Button>
      <Button variant="contained" color="secondary" endIcon={<CancelIcon />} onClick={onCancel}>
        {context.t('cancel')}
      </Button>
    </>
  );

  const content = (
    <Box sx={{ minWidth: 0, width: '100%', pt: 1 }}>
      <TextField
        fullWidth
        label={context.t('feedback')}
        multiline
        minRows={3}
        inputProps={{ maxLength: 225 }}
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
      />
    </Box>
  );

  return (
    <DraggableAppModal
      open={true}
      onClose={onCancel}
      closeIcon={true}
      hideBackdrop={false}
      maxWidth="sm"
      paperStyle={paperStyle}
      title={context.t('add_feedback_for_alert', { id: alert.alertId })}
      content={content}
      actions={actions}
    />
  );
};

AddFeedbackDialog.propTypes = {
  alert: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  paperStyle: PropTypes.object,
};
AddFeedbackDialog.contextTypes = { t: PropTypes.func.isRequired };

export default AddFeedbackDialog;
